import * as React from 'react';

import {TextField} from 'shells/textfield/textfield';

import type {DueDateUnit} from 'nutshell-graphql-types';
import type {ClosedLeadTaskTemplateDueDateInput} from 'nutshell-graphql-types';

import {DueUnitPicker} from '../fields/due-unit-picker';

import styles from '../date-time-picker.module.css';

type Props = {
    dueDate: ClosedLeadTaskTemplateDueDateInput;
    onDueDateChange: (arg1: ClosedLeadTaskTemplateDueDateInput) => void;
};

export class DueDateInputs extends React.PureComponent<Props> {
    render() {
        return (
            <div className={styles['date-picker']}>
                <div className={styles['timespan-input']}>
                    <TextField
                        type='number'
                        value={String(this.props.dueDate.dueTimespan)}
                        placeholder='0'
                        // @ts-expect-error
                        name='due-timespan'
                        onChange={this.handleDueTimespanChange}
                    />
                </div>
                <div className={styles['selector-container']}>
                    <DueUnitPicker
                        value={this.props.dueDate.dueUnit}
                        onChange={this.handleDueUnitChange}
                        isSingleUnit={this.props.dueDate.dueTimespan === 1}
                    />
                    <div className={styles['due-from']}>after the lead is closed</div>
                </div>
            </div>
        );
    }

    handleDueTimespanChange = (newValue: string) => {
        const newDueDate = {
            dueUnit: this.props.dueDate.dueUnit,
            dueTimespan: Number(newValue),
        } as const;

        this.props.onDueDateChange(newDueDate);
    };

    handleDueUnitChange = (newValue: {id: DueDateUnit}) => {
        const newDueDate = {
            dueTimespan: this.props.dueDate.dueTimespan,
            dueUnit: newValue.id,
        } as const;

        this.props.onDueDateChange(newDueDate);
    };
}
